export enum AccessProfileEnum {
    DESENVOLVIMENTO = 1,
    BACKOFFICE = 2,
    DIRETORIA = 4
}